import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=9738af44&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=9738af44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9738af44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9738af44')) {
      api.createRecord('9738af44', component.options)
    } else {
      api.reload('9738af44', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=9738af44&scoped=true&", function () {
      api.rerender('9738af44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24d3Wi1Kovvmu/JS/comp/GuestBox.vue"
export default component.exports